import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import SaveBlock from 'widgets/saveBlock';
import { TableLinksHelper } from 'entities/table/model/tableLinksHelper';
import { ModalProps } from 'shared/lib/components/modals/modal';
import { TableModel } from 'entities/table/model/tableModel';
import { useTranslation } from 'react-i18next';
import { MobxContext } from 'shared/lib/contexts/mobxContext';
import { UpdateTableHelper } from 'entities/table/model/updateTableHelper';

export default observer(function SaveTableController({
  tableHelper,
  tableModel,
  handleCancel,
}: {
  tableModel: TableModel;
  tableHelper: TableLinksHelper;
} & {
  handleCancel: ModalProps['handleClose'];
}) {
  const { t } = useTranslation();
  const { mobxStore } = useContext(MobxContext);

  return (
    <SaveBlock
      onCancel={handleCancel}
      onSubmit={async (params) => {
        if (!tableModel.data) {
          return;
        }
        try {
          const updateHelper = new UpdateTableHelper(tableModel.data);
          await updateHelper.update({
            id: tableModel.id,
            name: params.name || '',
            folder_id: params.folderId,
            section_id: params.sectionId,
            links: tableHelper.linksArray,
          });
          tableModel.updateLocally({
            name: params.name || '',
            folder_id: params.folderId,
            section_id: params.sectionId,
            links: tableHelper.linksArray,
          });

          tableModel.fetch({ in_trash: null });
          tableModel.fetchLinks({ in_trash: null });
          mobxStore.generateExplorerPageKey();
          handleCancel();
        } catch (e) {
          console.error(e);
          mobxStore.notificationsStore.errorMessage = t(
            'notifications.errors.default'
          );
        }
      }}
      isExternalDisabled={tableHelper.isSomeNotFilled}
      onSubmitValidationError={() => {
        tableHelper.isSubmitError = true;
      }}
      shouldHighlightValidation={tableHelper.isSubmitError}
      // TODO: дубль
      initialSectionId={tableModel?.data?.section_id || null}
      initialFolderId={tableModel?.data?.folder_id || null}
      nameParams={{
        label: t('formFields.tableName'),
        initialValue: tableModel?.data?.name || '',
      }}
      tableHelper={tableHelper}
    ></SaveBlock>
  );
});
